import ManipulacaoOrdemItemModel from "@/models/manipulacaoOrdemItemModel";
import ManipulacaoOrdemModel from "@/models/manipulacaoOrdemModel";
import IndicesConversoesUnidadeMedidasService from "@/services/indicesConversoesUnidadeMedidaService";
import ManipulacaoOrdemService from "@/services/manipulacaoOrdemService";

export enum ManipulacaoContextNewActions {
    ADD_ITEM_MANIPULACAO_NEW = "ADD_ITEM_MANIPULACAO_NEW",
    ADD_NEW_CONTEXT_NEW = "ADD_NEW_CONTEXT_NEW",
    CALCULA_DOSE_NEW = "CALCULA_DOSE_NEW",
    CALCULAR_QSP_NEW = "CALCULAR_QSP_NEW",
    CALCULAR_QUANTIDADES_ITEM_NEW = "CALCULAR_QUANTIDADES_ITEM_NEW",
    GET_MANIPULACAO_CONTEXT_NEW = "GET_MANIPULACAO_CONTEXT_NEW",
    REMOVE_ALL_ITENS_BY_TYPE_NEW = "REMOVE_ALL_ITENS_BY_TYPE_NEW",
    REMOVE_ATIVOS_ASSOCIADOS_NEW = "REMOVE_ATIVOS_ASSOCIADOS_NEW",
    REMOVE_ATIVOS_ASSOCIADOS_FORMA_FARMACEUTICA_NEW = "REMOVE_ATIVOS_ASSOCIADOS_FORMA_FARMACEUTICA_NEW",
    REMOVE_DESMEMBRADOS_NEW = "REMOVE_DESMEMBRADOS_NEW",
    REMOVE_ITEM_MANIPULACAO_NEW = "REMOVE_ITEM_MANIPULACAO_NEW",
    REPLICA_DOSE_ATIVOS_NEW = "REPLICA_DOSE_ATIVOS_NEW",
    RESET_MANIPULACAO_NEW = "RESET_MANIPULACAO_NEW",
    SET_ATIVO_PRINCIPAL_NEW = "SET_ATIVO_PRINCIPAL_NEW",
    SET_IS_CAPSULA_NEW = "SET_IS_CAPSULA_NEW",
    SET_IS_CONSOLIDANDO_NEW = "SET_IS_CONSOLIDANDO_NEW",
    SET_IS_DESABILITADO_NEW = "SET_IS_DESABILITADO_NEW",
    SET_MANIPULACAO_NEW = "SET_MANIPULACAO_NEW",
    SET_UPLOADING_EDITING_MODEL_NEW = "SET_UPLOADING_EDITING_MODEL_NEW",
    SET_UPLOADING_PREVENDA_NEW = "SET_UPLOADING_PREVENDA_NEW",
    UPDATE_ITENS_KIT_EMBALAGEM_NEW = "UPDATE_ITENS_KIT_EMBALAGEM_NEW",
    UPDATE_KIT_EMBALAGEM_ID_NEW = "UPDATE_KIT_EMBALAGEM_ID_NEW",
    UPDATE_MANIPULACAO_NEW = "UPDATE_MANIPULACAO_NEW",
    UPDATE_MANIPULACAO_KIT_EMBALAGEM_ID_NEW = "UPDATE_MANIPULACAO_KIT_EMBALAGEM_ID_NEW",
    UPDATE_MANIPULACAO_FROM_DESMEMBRADOS_NEW = "UPDATE_MANIPULACAO_FROM_DESMEMBRADOS_NEW",
    UPDATE_MANIPULACAO_ITENS_NEW = "UPDATE_MANIPULACAO_ITENS_NEW",
    CONSOLIDAR_NEW = "CONSOLIDAR_NEW",
    SET_FRANQUIA_FILIAL_NEW = "SET_FRANQUIA_FILIAL_NEW",
    SET_KIT_EMBALAGEM_OPTIONS_NEW = "SET_KIT_EMBALAGEM_OPTIONS_NEW",
}

export enum ManipulacaoContextNewMutations {
    ADD_ITEM_MANIPULACAO_NEW = "ADD_ITEM_MANIPULACAO_NEW",
    ADD_NEW_CONTEXT_NEW = "ADD_NEW_CONTEXT_NEW",
    CALCULAR_QSP_NEW = "CALCULAR_QSP_NEW",
    REMOVE_ALL_ITENS_BY_TYPE_NEW = "REMOVE_ALL_ITENS_BY_TYPE_NEW",
    REMOVE_ATIVOS_ASSOCIADOS_NEW = "REMOVE_ATIVOS_ASSOCIADOS_NEW",
    REMOVE_ATIVOS_ASSOCIADOS_FORMA_FARMACEUTICA_NEW = "REMOVE_ATIVOS_ASSOCIADOS_FORMA_FARMACEUTICA_NEW",
    REMOVE_DESMEMBRADOS_NEW = "REMOVE_DESMEMBRADOS_NEW",
    REMOVE_EMBALAGENS_BY_KIT_ID_NEW = "REMOVE_EMBALAGENS_BY_KIT_ID_NEW",
    REMOVE_ITEM_MANIPULACAO_NEW = "REMOVE_ITEM_MANIPULACAO_NEW",
    REPLICA_DOSE_ATIVOS_NEW = "REPLICA_DOSE_ATIVOS_NEW",
    RESET_MANIPULACAO_NEW = "RESET_MANIPULACAO_NEW",
    SET_ATIVO_PRINCIPAL_NEW = "SET_ATIVO_PRINCIPAL_NEW",
    SET_IS_CAPSULA_NEW = "SET_IS_CAPSULA_NEW",
    SET_IS_CONSOLIDANDO_NEW = "SET_IS_CONSOLIDANDO_NEW",
    SET_IS_DESABILITADO_NEW = "SET_IS_DESABILITADO_NEW",
    SET_ITEM_DATA_NEW = "SET_ITEM_DATA_NEW",
    SET_UPLOADING_EDITING_MODEL_NEW = "SET_UPLOADING_EDITING_MODEL_NEW",
    SET_UPLOADING_PREVENDA_NEW = "SET_UPLOADING_PREVENDA_NEW",
    UPDATE_ITENS_KIT_EMBALAGEM_NEW = "UPDATE_ITENS_KIT_EMBALAGEM_NEW",
    UPDATE_MANIPULACAO_NEW = "UPDATE_MANIPULACAO_NEW",
    UPDATE_MANIPULACAO_FROM_DESMEMBRADOS_NEW = "UPDATE_MANIPULACAO_FROM_DESMEMBRADOS_NEW",
    UPDATE_MANIPULACAO_KIT_EMBALAGEM_ID_NEW = "UPDATE_MANIPULACAO_KIT_EMBALAGEM_ID_NEW",
    CONSOLIDAR_NEW = "CONSOLIDAR_NEW",
    SET_FRANQUIA_FILIAL_NEW = "SET_FRANQUIA_FILIAL_NEW",
    SET_KIT_EMBALAGEM_OPTIONS_NEW = "SET_KIT_EMBALAGEM_OPTIONS_NEW",
}

export enum ItemTableType {
    ATIVO = 0,
    EMBALAGEM = 1,
    CAPSULA = 2,
}

export enum ItemTypeOrigem {
    OUTRO = 0,
    ITEM_PADRAO_FORMAFARMACEUTICA = 1,
}

export type ActionItemType = {
    type: ItemTableType;
    item?: ManipulacaoOrdemItemModel;
    index?: number;
    origem?: ItemTypeOrigem;
    noAddIfExists?: boolean;
};

export type UpdateItemType = {
    index: number;
    type: ItemTableType;
    item: ManipulacaoOrdemItemModel;
    force: boolean;
};

export type ResetManipulacaoType = {
    isItemFromVenda: boolean;
    isTransferencia: boolean;
    isVendaReplicada: boolean;
};

export class ManipulacaoContextNewState {
    ativos: ManipulacaoOrdemItemModel[] = [];
    capsulas: ManipulacaoOrdemItemModel[] = [];
    embalagens: ManipulacaoOrdemItemModel[] = [];
    desmembrados: ManipulacaoOrdemItemModel[] = [];
    uploadingEditingModel = false;
    uplodingPrevenda = false;
    indicesConversoesUnidadeMedidasService = new IndicesConversoesUnidadeMedidasService();
    manipulacaoOrdemService = new ManipulacaoOrdemService();
    isCapsula = false;
    isConsolidando = false;
    isDesabilitado = false;
    isItemFromVenda = false;
    isTransferencia = false;
    isVendaReplicada = false;
    manipulacao = new ManipulacaoOrdemModel();
    temProdutoListacontrolado = false;
    atualizaDadosLote = false;
    isFranquiaFilial = false;
    estoqueFranquiaId = 0;
    kitEmbalagensOptions: Array<Object> = [];
}

export type ManipulacaoContextUUIDNew<T> = {
    uuid: string;
    data: T;
};
